/* Progressive enhancement for Judge.me Cards. Review selection stays in Judge.me. */
(function () {
  'use strict';
  function productRoute(href, root, origin) {
    try {
      const url = new URL(href, origin);
      const match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/]+)\/?$/i);
      if (url.origin !== origin || !match || /%2f|%5c/i.test(match[1])) return null;
      const path = (root || '/').replace(/\/$/, '') + '/products/' + match[1];
      return { href: path + url.search + url.hash, json: path + '.js' };
    } catch (_) { return null; }
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { productRoute }; return; }
  const script = document.querySelector('script[data-cowmono-review-links]');
  if (!script) return;
  const root = script.dataset.localeRoot;
  const products = new Map();
  const states = new WeakMap();
  let pending = false;
  let activeRequests = 0;
  const queue = [];
  function drain() {
    while (activeRequests < 4 && queue.length) {
      activeRequests++;
      queue.shift()().finally(() => { activeRequests--; drain(); });
    }
  }
  function imageFor(route) {
    if (!products.has(route.json)) {
      const request = new Promise(resolve => {
        queue.push(async () => {
          try {
            const endpoint = new URL(route.href, location.origin);
            endpoint.searchParams.set('section_id', 'cowmono-review-product-image');
            const response = await fetch(endpoint, { credentials: 'same-origin' });
            if (!response.ok) { resolve(null); return; }
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = html.querySelector('[data-cowmono-review-product-image]');
            if (!data) { resolve(null); return; }
            const product = JSON.parse(data.textContent);
            const image = product.image;
            if (!product.id || typeof image !== 'string' || !image) { resolve(null); return; }
            const url = new URL(image, location.origin);
            resolve(url.protocol === 'https:' ? url.href : null);
          } catch (_) { resolve(null); }
        });
        drain();
      });
      products.set(route.json, request);
    }
    return products.get(route.json);
  }
  function enhance(card) {
    const native = card.querySelector('.jdgm-product-name > a:not(.cm-judgeme-product-thumbnail)');
    const route = native && productRoute(native.getAttribute('href'), root, location.origin);
    const previous = states.get(card);
    const reviewId = card.getAttribute('data-review-id') || '';
    const key = route ? reviewId + '|' + route.href + '|' + native.textContent.trim() : '';
    const thumbnail = card.querySelector('.cm-judgeme-product-thumbnail');
    if (previous?.key === key && (!previous.ready || thumbnail)) return;
    thumbnail?.remove();
    const state = { key, ready: false };
    states.set(card, state);
    if (!route) return;
    imageFor(route).then(src => {
      if (!src || !card.isConnected || states.get(card) !== state) return;
      const currentNative = card.querySelector('.jdgm-product-name > a:not(.cm-judgeme-product-thumbnail)');
      const current = currentNative && productRoute(currentNative.getAttribute('href'), root, location.origin);
      if (current?.href !== route.href || card.getAttribute('data-review-id') !== reviewId) return;
      const link = document.createElement('a');
      link.className = 'cm-judgeme-product-thumbnail';
      link.href = route.href;
      link.setAttribute('aria-label', currentNative.textContent.trim());
      const image = document.createElement('img');
      image.src = src;
      image.alt = '';
      image.width = 64;
      image.height = 64;
      image.loading = 'lazy';
      image.draggable = false;
      link.append(image);
      // Preserve normal browser navigation and prevent the review-popup handler.
      link.addEventListener('click', event => event.stopPropagation());
      link.addEventListener('keydown', event => event.stopPropagation());
      currentNative.parentElement.prepend(link);
      state.ready = true;
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      document.querySelectorAll('.jdgm-cards-carousel .jdgm-card').forEach(enhance);
    });
  }
  new MutationObserver(schedule).observe(document.body, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['href', 'data-review-id'], characterData: true
  });
  schedule();
})();
